import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {shareByEmail, shareBySMS, shareByWhatsapp} from './utils';
import {useReservation} from 'context/reservation';
import {environments} from 'configs';
import {copyToClipboard} from 'utils/common';
import {useSummary} from 'context/summary';
import {
  Title,
  Wrapper,
  InputContainer,
  LinkCopiedText,
  OrShareWithText,
  StyledButton,
  StyledCustomIcon,
  ContentCustomIcon,
  StyledInput,
} from './styled';
import {useTimeoutRef} from '@chekin/core';

const copiedLinkTimeoutS = 2;
const IS_SDK_MODE = environments.VITE_APP_IS_SDK;

function ShareRegistrationLink() {
  const {t} = useTranslation();
  const {housingName} = useSummary();
  const {data} = useReservation();
  const link = (IS_SDK_MODE ? window.location.href : data?.signup_form_link) || '';
  const timeoutRef = useTimeoutRef();
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const copyShareLinkToClipboard = () => {
    if (!link) return;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    copyToClipboard(link);
    setIsLinkCopied(true);
    timeoutRef.current = setTimeout(() => {
      setIsLinkCopied(false);
    }, copiedLinkTimeoutS * 1000);
  };

  return (
    <Wrapper className="share-link-modal">
      <Title className="share-link-modal__title">
        {t('share_registration_link_title')}
      </Title>
      <InputContainer className="share-link-modal__link">
        <StyledInput
          autoCorrect="off"
          spellCheck={false}
          value={link}
          autoFocus={false}
          disabled
        />
        <ContentCustomIcon onClick={copyShareLinkToClipboard}>
          <StyledCustomIcon name="copyLink" color={'#393ABD'} />
        </ContentCustomIcon>
        {isLinkCopied && <LinkCopiedText>{t('link_copied')}</LinkCopiedText>}
      </InputContainer>
      <OrShareWithText>{t('or_share_by')}:</OrShareWithText>
      <StyledButton
        label={t('whatsapp')}
        onClick={() => shareByWhatsapp(housingName, link)}
        outlined
      />
      <StyledButton
        label={t('sms')}
        onClick={() => shareBySMS(housingName, link)}
        outlined
      />
      <StyledButton
        label={t('email')}
        onClick={() => shareByEmail(housingName, link)}
        outlined
      />
    </Wrapper>
  );
}

export {ShareRegistrationLink};
